import { Tooltip } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import CommonTransactionTable from "../../../common/components/CommonTable/CommonTransactionTable";
import SearchDropdown from "../../../common/components/FormFields/searchDropdown";
import { warningAlert } from "../../../common/components/Toasts/CustomToasts";
import TableDropDownField from "./TableDropdownField";
import CustomInput from "../../../common/components/CustomInput";
import { getICDCodeSerachBy } from "../services/EMRServices/emrServices";
import { DeleteIcon } from "./EmrCommonAsset/Asset";
import PastDiagnosis from "./PastDiagnosis";
const durationData = [
  {
    value: "Days",
    label: "D",
  },
  {
    value: "Months",
    label: "M",
  },
  {
    value: "Years",
    label: "Y",
  },
];
const statusOption = [
  {
    id: "Provisional",
    value: "Provisional",
    label: "Provisional",
  },
  {
    id: "Final",
    value: "Final",
    label: "Final",
  },
];
export default function OPDDiagnosis(props) {
  const {
    diagnosisData,
    setDiagnosisData,
    dataDiagnosis,
    setDataDiagnosis,
    markFavoriteData,
    patientHistoryData,
    setPatientHistoryData,
  } = props;

  const [allDiagnosisChipsList, setAllDiagnosisChipsList] = useState([]);
  const [chipsCount, setChipsCount] = useState(5);
  const [save, setSave] = useState(false);
  const [openPastDiagnosis, setOpenPastDiagnosis] = useState(false);
  const [diagnosis, setDiagnosis] = useState([]);

  const {
    handleSubmit,
    reset,
    formState: { errors },
    control,
    register,
    watch,
    setValue,
  } = useFormContext({});
  function deleteRow(index) {
    const newComplaintsData = [...diagnosisData];
    newComplaintsData.splice(index, 1);
    setDiagnosisData(newComplaintsData);
    setDataDiagnosis(newComplaintsData);
  }
  const renderAction = (row, index) => {
    return (
      <div className="flex gap-2">
        <Tooltip title="Delete">
          <button
            type="button"
            onClick={() => {
              deleteRow(index);
            }}
          >
            <DeleteIcon />
          </button>
        </Tooltip>
      </div>
    );
  };

  useEffect(() => {
    if (save === true) {
      setDiagnosisData([...dataDiagnosis]);
      setSave(false);
    }
  }, [save]);
  const handleChange = (e) => {
    if (e !== undefined && e !== "") {
      getICDCodeSerachBy(
        props.patientVisitedDepartmentId,
        props.doctorId,
        e,
      ).then((response) => {
        setDiagnosis(response.data.result);
      });
    } else if (e === "" || e === undefined || e === null) {
      setDiagnosis([]);
    }
  };
  let diagnosisWatch = watch("diagnosis");
  let since = watch("since");
  let duration = watch("duration");
  let chronic = watch("chronic");
  let status = watch("status");
  console.log("statusstatusstatus", status);

  useEffect(() => {
    if (
      diagnosisWatch !== null &&
      diagnosisWatch !== undefined &&
      diagnosisWatch !== ""
    ) {
      let obj = {
        diagnosis: diagnosisWatch?.label,
        since: since,
        duration: duration?.label,
        status: status?.label,
        chronic: chronic,
        isNew:
          diagnosisWatch?.__isNew__ !== undefined &&
          diagnosisWatch?.__isNew__ === true
            ? true
            : false,
        // isNew: true,
      };
      let temp = diagnosisData.some(
        (item) => item.diagnosis === diagnosisWatch?.label,
      );
      if (temp === true) {
        warningAlert("Already Present Record..!");
      } else {
        if (diagnosisWatch !== null && diagnosisWatch !== undefined) {
          setDiagnosisData((prevState) => [...prevState, obj]);
          setValue("diagnosis", null);
          setValue("since", "");
          setValue("duration", null);
          setValue("chronic", false);
          setValue("statusOpd", "Provisional");
        } else {
          warningAlert("Please Fill The Record");
        }
      }
    }
  }, [diagnosisWatch]);
  const renderInput = (row, index, header) => {
    console.log("row454545", row);

    setValue(
      `duration${index}`,
      row.Since !== "" && row.Since !== undefined
        ? {
            value: "Days",
            label: "Days",
          }
        : {
            value: row.Duration,
            label: row.Duration,
          },
    );
    setValue(`status${index}`, {
      value: row.Status,
      label: row.Status,
    });
    setValue(`sinceDia${index}`, row.Since);
    // setValue(`chronic${index}`,row?.Chronic)
    return (
      <>
        {header === "Duration" && (
          <div className="flex gap-2 w-full">
            {durationData.map((item, durationIndex) => {
              return (
                <div className="flex gap-2 ">
                  <button
                    // disabled={pastData !== null}
                    disabled={row?.Since === "" || row.Since === undefined}
                    type="button"
                    onClick={(e) => {
                      let tempData = [...diagnosisData];
                      if (tempData[index].duration === item.value) {
                        tempData[index].duration = null;
                      } else {
                        tempData[index].duration = item?.value;
                      }
                      setDiagnosisData(tempData);
                    }}
                    className={`${
                      row.Duration === item?.value
                        ? "bg-[#29adda] text-white rounded-full border"
                        : "text-black rounded-full border"
                    } w-5 h-5 pt-[2px] border border-gray-400 pl-[1px] rounded-full text-[12px] font-semibold`}
                  >
                    {item?.label}
                  </button>
                </div>
              );
            })}
          </div>
        )}
        {header === "Since" && (
          <div className="w-20">
            <CustomInput
              control={control}
              name={`sinceDia${index}`}
              // label="Since"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
              inputRef={{
                ...register(`sinceDia${index}`, {
                  onChange: (e) => {
                    let tempData = [...diagnosisData];
                    tempData[index].since = e.target.value;
                    if (
                      tempData[index].duration === undefined ||
                      tempData[index].duration === ""
                    ) {
                      tempData[index].duration = "Days";
                    } else if (
                      tempData[index].duration !== undefined ||
                      tempData[index].duration !== ""
                    ) {
                      tempData[index].duration = " ";
                    }
                    setDiagnosisData(tempData);
                  },
                }),
              }}
            />
          </div>
        )}
        {header === "Status" && (
          <div className="w-48">
            <TableDropDownField
              control={control}
              name={`status${index}`}
              // placeholder="Status"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
              dataArray={statusOption}
              inputRef={{
                ...register(`status${index}`, {
                  onChange: (e) => {
                    let tempData = [...diagnosisData];
                    tempData[index].status = e.target.value?.label;
                    setDiagnosisData(tempData);
                  },
                }),
              }}
              menuPlacement="bottom"
            />
          </div>
        )}
        {header === "Chronic" && (
          <div className="w-16">
            <input
              type="checkbox"
              name={`chronic${index}`}
              checked={row.Chronic}
              onChange={(e) => {
                let tempData = [...diagnosisData];
                tempData[index].chronic = e.target.checked;
                setDiagnosisData(tempData);
              }}
            />
          </div>
        )}
      </>
    );
  };
  const mergeArray = (arr) => {
    return arr.reduce((acc, val) => {
      const ind = acc.findIndex((item) => item.diagnosis === val.diagnosis);
      if (ind !== -1) {
        console.log("instruction Already Exists");
      } else {
        acc.push(val);
      }
      return acc;
    }, []);
  };
  return (
    <div className="">
      <div className="flex justify-between bg-[#D6FEF4] rounded-t-md ">
        <div className="">
          <p className="text-sm font-semibold pl-2 py-1">Diagnosis</p>
        </div>

        <div className="flex gap-2 w-72">
          <fieldset
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
              }
            }}
            className="w-full"
          >
            <SearchDropdown
              // ref={selectRef}
              focused={true}
              control={control}
              // error={errors.allergyType}
              name="diagnosis"
              label="Diagnosis"
              placeholder="Diagnosis"
              dataArray={diagnosis}
              isSearchable={false}
              handleChange={handleChange}
              onInputChange={handleChange}
            />
          </fieldset>
        </div>
      </div>
      <div
        className={`${
          props.from === "Orthopedic" ? "h-32" : "h-32"
        } border  overflow-auto  border-b-[#D9D9D9] border-r-[#D9D9D9] border-l-[#D9D9D9] bg-white rounded-b-md`}
      >
        <div className="flex justify-between ">
          <div className="flex flex-wrap space-x-2 pl-2">
            {markFavoriteData?.diagnosis &&
              markFavoriteData?.diagnosis
                .slice(0, chipsCount)
                .map((item, index) => {
                  const isCheck = allDiagnosisChipsList?.some(
                    (val) => val?.diagnosis === item.label,
                  );

                  return (
                    <>
                      <button
                        type="button"
                        key={index}
                        className={`mr-[5px] mb-1 capitalize h-[27px] px-3 w-max rounded text-sm border border-gray-300 whitespace-nowrap ${
                          diagnosisData?.some(
                            (val) => val?.diagnosis === item.label,
                          )
                            ? "bg-[#32819b] text-white rounded-full border"
                            : "text-black rounded-full border"
                        }`}
                        disabled={diagnosisData.some(
                          (val) => val?.diagnosis === item.label,
                        )}
                        onClick={() => {
                          setValue("diagnosis", item);
                        }}
                      >
                        {item.label}
                      </button>
                      {/* )} */}
                    </>
                  );
                })}
          </div>
        </div>
        {diagnosisData !== undefined && diagnosisData?.length > 0 ? (
          <div className="">
            <CommonTransactionTable
              dataResult={mergeArray(diagnosisData).map((row) => ({
                Diagnosis: row.diagnosis,
                Since: row.since,
                Duration: row.duration,
                Status: row.status,
                Chronic: row.chronic,
              }))}
              renderActions={renderAction}
              highlightRow={false}
              editableColumns={["Duration", "Since", "Chronic", "Status"]}
              renderInput={renderInput}
            />
          </div>
        ) : null}

        <div className=""></div>
        <div>
          <PastDiagnosis
            patientHistoryData={patientHistoryData}
            setPatientHistoryData={setPatientHistoryData}
            openPastDiagnosis={openPastDiagnosis}
            setOpenPastDiagnosis={setOpenPastDiagnosis}
          />
        </div>
      </div>
    </div>
  );
}
